import AccessDeviceIcon from '@material-ui/icons/ViewList';

import MerchantList from './MerchantList';

export default {
    list: MerchantList,
    icon: AccessDeviceIcon,
};
